export enum AlertState
{
    Unread = "Unread",
    Read = "Read",
    Traded = "Traded"
}